import React, { useEffect, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import fetchData from "verticales/FetchData";
import AppLoading from "verticales/AppLoading.tsx";
import iconClientes from "assets/images/icons/icono_clientes.ico";
import { useNavigate } from "react-router-dom";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "informes";

function ClientesSiesa() {
  const [numeroClientes, setNumeroClientes] = useState(0);
  const [diferenciaClientes, setDiferenciaClientes] = useState(0);
  const [blocking, setBlocking] = React.useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const catData = async () => {
      setBlocking(true);
      const data = await fetchData(url, context, { action: "dashboard-clientes-erp-siesa" });
      console.log("data..............", data);
      if (data?.rows?.length > 0) {
        const obj = data.rows[0];
        //console.log("obj....", obj["numero_clientes"]);
        setNumeroClientes(obj["numero_clientes"]);
      } else if (data?.error && data.error >= 399 && data.error <= 500) {
        // console.log("hola como estas!!!!!!!!!!!!!!!!");
        navigate("/login");
      }
      const diferenciaData = await fetchData(url, context, {
        action: "diferencial-clientes",
      });
      if (diferenciaData?.rows?.length > 0) {
        const obj = diferenciaData.rows[0];
        const diferencia = Number(obj["diferencia"]); // Usamos la columna "diferencia"
        setDiferenciaClientes(isNaN(diferencia) ? 0 : diferencia); // Si no es un número, lo define como 0
      }
      setBlocking(false);
    };
    catData();
  }, []);
  return (
    <Grid item xs={12} md={6} lg={3}>
      <MDBox mb={1.5}>
        {blocking ? (
          <AppLoading titleCustom={"Clientes Siesa"} />
        ) : (
          <ComplexStatisticsCard
            color="dark"
            icon={<img src={iconClientes} />}
            title="Clientes Siesa"
            count={numeroClientes}
            percentage={{
              color: "success",
              amount: diferenciaClientes,
              label: "Clientes al mes anterior",
            }}
          />
        )}
      </MDBox>
    </Grid>
  );
}

export default ClientesSiesa;
